import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput, {
  formatLatexPreview
} from "../../../../components/inputs/FractionInput";

/* Helpers */
const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

function argLatexFromK(k) {
  if (k === 0) return "1";
  if (k === 0.5) return "\\sqrt{10}";
  if (Number.isInteger(k) && k > 0) return String(10 ** k);
  if (Number.isInteger(k) && k < 0) return `\\dfrac{1}{${10 ** -k}}`;
  return `10^{${k}}`;
}

/* Generator */
export function generateTask() {
  const exps = [-6, -5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5, 6, 0.5];
  const k = pick(exps);
  const argLatex = argLatexFromK(k);
  return { type: "LogCommonTask", data: { k, argLatex } };
}

/* Render */
export function renderTask({ data }) {
  return (
    <div style={{ marginBottom: "12px" }}>
      <div>Oblicz wartość logarytmu dziesiętnego:</div>
      <BlockMath math={`\\log\\, ${data.argLatex}`} />
    </div>
  );
}

export function renderInput(task, userAnswer, onChange, disabled) {
  const handleChange = (ans) => {
    onChange && onChange(ans);
  };

  return (
    <div className="space-y-2">
      {/* Bez prefiksu typu "log ..." nad polem */}
      <div>
        <InlineMath math="" />
      </div>

      <FractionInput
        value={userAnswer}
        onChange={handleChange}
        disabled={disabled}
        // pusty label → w podglądzie tylko liczba
        label=""
      />
    </div>
  );
}


/* Checking */
export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  const given = userAnswer.parsed;
  if (given == null) return false;
  return Math.abs(given - data.k) < 1e-4;
}

/* Twoja odpowiedź – sama liczba */
export function renderUserAnswer(userAnswer /*, task */) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }
  return <InlineMath math={formatLatexPreview(userAnswer.raw)} />;
}

/* Poprawna odpowiedź – też sama liczba */
export function renderAnswer({ data }) {
  return <InlineMath math={String(data.k)} />;
}

/* Explanation */
export function renderExplanation({ data }) {
  const { k, argLatex } = data;
  let step2;
  if (k === 0.5) {
    step2 = `10^{\\frac{1}{2}} = \\sqrt{10}`;
  } else if (Number.isInteger(k) && k >= 0) {
    step2 = `10^{${k}} = ${argLatex}`;
  } else if (Number.isInteger(k) && k < 0) {
    const m = -k;
    step2 = `10^{${k}} = \\dfrac{1}{10^{${m}}} = \\dfrac{1}{${10 ** m}}`;
  } else {
    step2 = `10^{${k}} = ${argLatex}`;
  }

  return (
    <div className="space-y-2">
      <p>
        <strong>Krok 1:</strong> Definicja logarytmu dziesiętnego:
      </p>
      <BlockMath math={"\\log x = k\\;\\iff\\;10^{k}=x"} />
      <p>
        <strong>Krok 2:</strong> Podstawiamy:
      </p>
      <BlockMath math={step2} />
      <p>
        <strong>Wniosek:</strong>
      </p>
      <BlockMath math={`\\log\\, ${argLatex} = ${k}`} />
    </div>
  );
}
